import { v4 as uuidv4 } from 'uuid';
import { useSeti } from '../utils/useSeti';
export const getPayloadConfig = ({
  customerName,
  locale,
  startingChatMessagesPayload,
  viewType,
  webstats
}) => {
  const dateToday = new Date().toString();
  const rguidSeed = uuidv4();
  const standardConfig = {
    cguid: (webstats === null || webstats === void 0 ? void 0 : webstats.clientGUID) || '',
    cityName: (locale === null || locale === void 0 ? void 0 : locale.city) || '',
    countryCode: (locale === null || locale === void 0 ? void 0 : locale.countryName) || '',
    customerName,
    dateToday,
    isSessionActive: true,
    latitude: (locale === null || locale === void 0 ? void 0 : locale.latitude) || '',
    longitude: (locale === null || locale === void 0 ? void 0 : locale.longitude) || '',
    resolvedClientIP: (webstats === null || webstats === void 0 ? void 0 : webstats.resolvedClientIP) || '',
    stateCode: (locale === null || locale === void 0 ? void 0 : locale.region) || ''
  };
  const payloadConfig = {
    LANDING: {
      isMobile: webstats === null || webstats === void 0 ? void 0 : webstats.isMobile,
      submitChatMessagesPayload: Object.assign(Object.assign(Object.assign({
        productId: 5,
        returnJSONResponse: true,
        rguid: `HOMEPAGE-${rguidSeed}`
      }, standardConfig), startingChatMessagesPayload), {
        // Moved from featureConfig
        hotelPayload: {
          shouldUseSearchHotelsFeature: true,
          isHotelSearchDateSelection: true,
          isShowMoreListingCards: useSeti({
            testName: 'CHATBOT_HOTEL_CARDS_LOAD_MORE',
            shouldFireImpression: false
          })
        },
        enabledActions: {
          shouldEnableFeedbackIntent: true,
          shouldEnableInlineLocationMetadata: true,
          shouldEnableLLMBasedResult: true,
          shouldEnableSelectedTripQuickActions: true,
          shouldUseDynamicQuickActionsChips: true
        }
      })
    },
    PORTAL: {
      isMobile: webstats === null || webstats === void 0 ? void 0 : webstats.isMobile,
      submitChatMessagesPayload: Object.assign(Object.assign(Object.assign({
        isSessionActive: true,
        productId: -1,
        returnJSONResponse: true
      }, standardConfig), startingChatMessagesPayload), {
        hotelPayload: {
          shouldUseSearchHotelsFeature: true,
          isHotelSearchDateSelection: true,
          isShowMoreListingCards: useSeti({
            testName: 'CHATBOT_HOTEL_CARDS_LOAD_MORE',
            shouldFireImpression: false
          })
        },
        // Moved from featureConfig
        enabledActions: {
          shouldEnableFeedbackIntent: true,
          shouldEnableInlineLocationMetadata: true,
          shouldEnableLLMBasedResult: true,
          shouldEnableSelectedTripQuickActions: true,
          shouldUseDynamicQuickActionsChips: true
        },
        pennyPortalPayload: {
          shouldUseSearchHotelsFeature: true
        }
      })
    }
    // STAYDETAILS: {
    //     ...standardConfig,
    //     ...startingChatMessagesPayload,
    // },
    // STAYLISTINGS: {
    //     ...standardConfig,
    //     ...startingChatMessagesPayload,
    // },
    // ITINERARY: {
    //     ...standardConfig,
    //     ...startingChatMessagesPayload,
    // },
    // FLY: {
    //     ...standardConfig,
    //     ...startingChatMessagesPayload,
    // },
    // DRIVE: {
    //     ...standardConfig,
    //     ...startingChatMessagesPayload,
    // },
    // PACKAGE: {
    //     ...standardConfig,
    //     ...startingChatMessagesPayload,
    // },
    // CHECKOUT: {
    //     ...standardConfig,
    //     ...startingChatMessagesPayload,
    // }
  };
  // Ensure viewType has a valid payload config
  const config = payloadConfig[viewType];
  if (!config) {
    throw new Error(`No payload configuration found for viewType: ${viewType}. ` + 'Add configuration to payloadConfig object in /react-components/penny-chat-bot/src/config/payloadConfig.ts. ');
  }
  return config;
};